import { render, staticRenderFns } from "./Dining.vue?vue&type=template&id=258d9f04&scoped=true&"
import script from "./Dining.vue?vue&type=script&lang=js&"
export * from "./Dining.vue?vue&type=script&lang=js&"
import style0 from "./Dining.vue?vue&type=style&index=0&id=258d9f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258d9f04",
  null
  
)

export default component.exports